import types from "./types";

export const initForm = (formId, initialValues) => ({
    type: types.INIT_FORM,
    payload: { formId, initialValues },
});

export const resetForm = (formId) => ({
    type: types.RESET_FORM,
    payload: { formId },
});

export const setFormErrors = (error) => ({
    type: types.SET_FORM_ERRORS,
    payload: error,
});

export const removeFormErrors = (errorName) => ({
    type: types.REMOVE_FORM_ERROR,
    payload: errorName,
});

export const resetFormErrors = () => ({
    type: types.RESET_FORM_ERRORS,
});
